//import 'ol/ol.css';
import { Map, Feature } from 'ol';
import * as toastr from "toastr";
import { INode, FeatureType, IFeatureTypeOptions, ICAMSKey, IFeaturesRequest, IMapInteractionConfig, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import { Utilities } from '../Shared/Utility/Utilities';
import { Reparent } from './Reparent';
import * as events from '../Shared/Bus/Bus';
import { ReportModel, SystemType } from '../Reports/ReportsModels';
import * as AuthModel from '../Shared/Models/AuthModel';

export class OfficerMapMapSelect {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;
    private treeView: any;
    private treeData: Array<INode> = [];
    private reparent: Reparent = new Reparent();

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults
    // List of buttions in the action toolbar
    private actionBtns = {
        viewprint: { btn: $('#treePrintBtn button'), enable: false },
        map: { btn: $('#treeZoomToMapSelectedBtn button'), enable: false },
        export: { btn: $('#treeExportSelectedBtn button'), enable: false },
        edit: { btn: $('#treeEditBtn button'), enable: false },
        annotate: { btn: $('#treeAnnotateBtn button'), enable: false },
        reparent: { btn: $('#treeReParentBtn button'), enable: false },
        newTask: { btn: $('#treeNewTaskBtn button'), enable: false }
    };

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: Map, protected authModel: AuthModel.IAuthModel) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        $('#treeSelectCloseBtn').on("click", function () {
            self.closeTreeSelectPanel();
        });
        $('#treeCloseBtn').on("click", function () {
            self.closeTreeResultsPanel();
        });

        $('#treeSelectStartProcessBtn').on("click", function () { self.StartSelectProcess(); self.closeTreeSelectPanel(); });
        $('#treeResultsSelectedFeaturesBtn').on("click", function () { self.openTreeResultsPanel(); });
        $('#treeResultsSelectedFeatures_ClearBtn').on("click", function () { self.ClearSelection(); });
        $('#treeSelectClearBtn').on("click", function () { self.ClearSelection(); });
        $('#treeSelectAllBtn').on('change', function () {
            if ($('#treeSelectAllBtn').is(":checked") == true) {
                self.treeView.treeview('checkAll', { silent: true });
            }
            else {
                self.treeView.treeview('uncheckAll', { silent: true });
            }
            self.checkVisibleButtons();
            self.updateNumberCheckedMessage();
        });

        $('#treeClearAllBtn').on("click", function () { self.DeleteAllNodes(); });
        $('#treeRectangleSelectOptions select').on('change', function () { self.newEntityTypeSelected(); });
        $('#treeZoomToMapSelectedBtn').on("click", function () { self.ZoomToChecked(); });
        $('#treeExportSelectedBtn').on('click', function () { toastr.info('To be completed'); });
        $('#treeExpandAllBtn').on('click', function () { self.ExpandAllNodes(); });
        $('#treeCollapseAllBtn').on('click', function () { self.CollapseAllNodes(); });
        $('#treeAnnotateBtn').on('click', function () {
            var nodes: Array<INode> = self.treeView.treeview('getChecked');
            nodes = nodes.concat(self.treeView.treeview('getSelected'));
            let data: ICAMSKey = { code: nodes[0].href, featureType: nodes[0].featureType };
            events.bus.publish(events.eventShowAnnotationsForFeature([data, true]));
            this.blur();
        });
        $('#treePrintBtn').on('click', function () {
            var nodes: Array<INode> = self.treeView.treeview('getSelected');
            nodes = nodes.concat(self.treeView.treeview('getChecked')); // This makes sure we get all selected and checked nodes

            let data: ReportModel;
            var values: Array<string> = [];
            nodes.forEach(n => values.push(n.href));

            if (nodes[0].featureType == FeatureType.Maint) {
                data = { reportParameters: [{ name: "codes", values: values }] };
                if (nodes.length == 1) { data.systemType = SystemType.OfficerMap_RecordList_Maint_Single; }
                else { data.systemType = SystemType.OfficerMap_RecordList_Maint_Multi; }
            }
            else if (nodes[0].featureType == FeatureType.Infra) {
                data = { reportParameters: [{ name: "codes", values: values }] };
                if (nodes.length == 1) { data.systemType = SystemType.OfficerMap_RecordList_Infra_Single; }
                else { data.systemType = SystemType.OfficerMap_RecordList_Infra_Multi; }
            }
            else if (nodes[0].featureType == FeatureType.Route) {
                data = { reportParameters: [{ name: "codes", values: values }] };
                if (nodes.length == 1) { data.systemType = SystemType.OfficerMap_RecordList_Route_Single; }
                else { data.systemType = SystemType.OfficerMap_RecordList_Route_Multi; }
            }
            else if (nodes[0].featureType == FeatureType.Land) {
                data = { reportParameters: [{ name: "codes", values: values }] };
                if (nodes.length == 1) { data.systemType = SystemType.OfficerMap_RecordList_Land_Single; }
                else { data.systemType = SystemType.OfficerMap_RecordList_Land_Multi; }
            }
            else if (nodes[0].featureType == FeatureType.Path) {
                data = { reportParameters: [{ name: "codes", values: values }] };
                if (nodes.length == 1) { data.systemType = SystemType.OfficerMap_RecordList_Path_Single; }
                else { data.systemType = SystemType.OfficerMap_RecordList_Path_Multi; }
            }

            var selectedMsg = "Selected Map Records (" + values.length + ")";
            events.bus.publish(events.eventOpenReportOrSelectList([data, selectedMsg]));
            this.blur();
        });
        self.actionBtns.edit.btn.on('click', function () {
            var nodes: Array<INode> = self.treeView.treeview('getChecked');
            nodes = nodes.concat(self.treeView.treeview('getSelected'));
            let data: ICAMSKey = { code: nodes[0].href, featureType: nodes[0].featureType };
            events.bus.publish(events.eventOpenEditPanel(data));
            this.blur();
        });
        self.actionBtns.reparent.btn.on('click', function () {
            var nodes: Array<INode> = self.treeView.treeview('getChecked');
            nodes = nodes.concat(self.treeView.treeview('getSelected'));
            let data: Array<ICAMSKey> = [];
            nodes.forEach(n => { data.push({ code: n.href, featureType: n.featureType }); });
            self.reparent.wizard_Start(data);
            this.blur();
        });
        self.actionBtns.newTask.btn.on('click', function () {
            var nodes: Array<INode> = self.treeView.treeview('getChecked');
            nodes = nodes.concat(self.treeView.treeview('getSelected'));
            let data: Array<ICAMSKey> = nodes.map(n => { return { code: n.href, featureType: n.featureType } });
            events.bus.publish(events.eventOpenTasksCreatePanel([data, function (r) {
                events.bus.publish(events.eventEntityUpdated(data[0]));
            }]));

            this.blur();
        });
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openTreeSelectPanel = (): void => {
        this.updateSelectionCountMessage();
        $('#treeSelectPanel').addClass('show');
        this.StartSelectProcess();
    }

    public closeTreeSelectPanel = (): void => {
        $('#treeSelectPanel').removeClass('show');
    }

    public closeTreeResultsPanel = (): void => {
        events.bus.publish(events.eventResetRightPanels());
        $('#mapTreeSelectBtn').addClass('mapActionSelected');
    }

    public openTreeResultsPanel = (): void => {
        // Close this panel and open the results
        events.bus.publish(events.eventResetRightPanels());
        $('#treeResultsPanel').addClass('show');
        $('#mapTreeSelectBtn').addClass('mapActionSelected');
    }

    public AddNodesToTree = (data: IFeaturesRequest): void => {
        const self = this;
        let optionStr = $('#treeRectangleSelectOptions select').children("option:selected").val();
        if (optionStr == "path") {
            data.ReturnPathsOnly = true;
        }
        let query = { data: data };

        if (self.treeData != null && self.treeData.length == 0) {
            if ($('#rightSelectGroupPanel').hasClass('show') == false) $('#rightSelectGroupPanel').addClass('show');
            $('#treeResultsSelectedFeaturesPanel').show();
            $('#treeSelectCurrentCountMessage').html("Retrieving data...");
        }

        Utilities.BlockUI($('#treeSelectPanelContainer'));
        Utilities.BlockUI($('#treeResultsSelectedFeaturesPanel'), null, null);
        $.post(window.G_SITEFOLDERNAME + '/OfficerMap/GetTreeData', query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data = result.data.nodes as Array<INode>;
                        self.addData_to_treeData(data);
                        self.createTree(self.treeData, true);
                        self.updateSelectionCountMessage();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI($('#treeSelectPanelContainer'));
                    Utilities.UnBlockUI($('#treeResultsSelectedFeaturesPanel'));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    public DeleteNodesFromTree = (data: Array<ICAMSKey>): void => {
        data.forEach(d => {
            this.removeData_from_treeData(d);
        });

        this.createTree(this.treeData, true);
    }

    public DeleteAllNodes = (): void => {
        this.treeData = [];
        this.createTree(this.treeData, true);
        events.bus.publish(events.eventClearSelectedFeatures());
    }

    public ExpandAllNodes = (): void => {
        this.treeView.treeview('expandAll', { silent: true });
    }

    public CollapseAllNodes = (): void => {
        this.treeView.treeview('collapseAll', { silent: true });
    }

    public StartSelectProcess = (): void => {
        let data: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: true };
        let optionStr = $('#treeRectangleSelectOptions select').children("option:selected").val();
        switch (optionStr) {
            case "all":
                data.selectableLayers = [FeatureType.Route, FeatureType.Route, FeatureType.Infra, FeatureType.Maint];
                break;
            case "Route":
                data.selectableLayers = [FeatureType.Route];
                Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "FeatureName_Links" }]).then(m => {
                    if (m.success == true) $('#treeResultsPanelHeaderTitle').html(m.data[0].value + " ");
                    else $('#treeResultsPanelHeaderTitle').html("Links ");
                });
                break;
            case "Maint":
                data.selectableLayers = [FeatureType.Maint];
                Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "FeatureName_Issues" }]).then(m => {
                    if (m.success == true) $('#treeResultsPanelHeaderTitle').html(m.data[0].value + " ");
                    else $('#treeResultsPanelHeaderTitle').html("Issues ");
                });
                break;
            case "Infra":
                data.selectableLayers = [FeatureType.Infra];
                Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "FeatureName_Furniture" }]).then(m => {
                    if (m.success == true) $('#treeResultsPanelHeaderTitle').html(m.data[0].value+" ");
                    else $('#treeResultsPanelHeaderTitle').html("Furniture ");
                });
                
                break;
            case "Land":
                data.selectableLayers = [FeatureType.Land];
                Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "FeatureName_Land" }]).then(m => {
                    if (m.success == true) $('#treeResultsPanelHeaderTitle').html(m.data[0].value + " ");
                    else $('#treeResultsPanelHeaderTitle').html("Land ");
                });
                break;
            case "Path":
                data.selectableLayers = [FeatureType.Path];
                Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "FeatureName_Path" }]).then(m => {
                    if (m.success == true) $('#treeResultsPanelHeaderTitle').html(m.data[0].value + " ");
                    else $('#treeResultsPanelHeaderTitle').html("Paths ");
                });
                break;
        }

        events.bus.publish(events.eventTreeStartMultiAndRectangleMapSelected(data));

    }

    public multiSelectionComplete = (features: Array<Feature>): void => {
        let query: IFeaturesRequest = { maintCodes: [], infraCodes: [], infraHistoricCodes: [], routeCodes: [], landCodes: [], annotationGeomIDs: [], troGeomIDs: [], legalRoutes: [], legalFeatures: [] };
        features.forEach(f => {
            var p = f.getProperties();
            if (p.MaintCode != null) {
                query.maintCodes.push(p.MaintCode);
            }
            else if (p.InfraCode != null) {
                query.infraCodes.push(p.InfraCode);
            }
            else if (p.RouteCode != null) {
                query.routeCodes.push(p.RouteCode);
            }
            else if (p.LandCode != null) {
                query.landCodes.push(p.LandCode);
            }
        });

        this.AddNodesToTree(query);
    }

    public rectangleSelectionComplete = (data: IFeaturesRequest): void => {
        this.AddNodesToTree(data);
    }

    public ZoomToChecked = (): void => {
        const self = this;
        var nodes: Array<INode> = self.treeView.treeview('getChecked');
        nodes = nodes.concat(self.treeView.treeview('getSelected'));

        var wktArr = []; var featureType;
        nodes.forEach(n => {
            if (n.wkt != null) {
                wktArr.push(n.wkt);
                featureType = n.featureType;
            }
        });
        events.bus.publish(events.eventZoomToWKTandHighlight([wktArr, true, true, featureType]));
    }

    public GetMapSelectRecords = (callback: Function): void => {
        callback(this.treeData);
    }

    // ----------------------------------------------------------- //
    // SELECT CHANGE
    public newEntityTypeSelected = (): void => {
        this.DeleteAllNodes();
        events.bus.publish(events.eventClearSelectedFeatures());
        this.updateSelectionCountMessage();
        this.StartSelectProcess();
    }

    // ----------------------------------------------------------- //
    // CREATE/ADD data
    private createTree = (data: Array<INode>, colapseAll: boolean): void => {
        const self = this;

        var tree: any = $('#treeView');
        self.treeView = tree.treeview({
            data: data,
            showCheckbox: true,
            multiSelect: false,
            onNodeSelected: function (event, node) {
                let data: ICAMSKey = { code: node.href, featureType: node.featureType };
                if (node.doNotOpenEditForm != true) {
                    events.bus.publish(events.eventOpenEditPanel(data));
                }
                var nodeA = self.treeView.treeview('getNode', node.nodeId);
                nodeA.doNotOpenEditForm = null; // Remove this temp settings

                self.treeView.treeview('uncheckAll', [{ silent: true }]);
                self.checkVisibleButtons(node);
                self.updateNumberCheckedMessage();
            },
            onNodeUnselected: function (event, node) {
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            },
            onNodeChecked: function (event, node) {
                self.treeView.treeview('unselectAll', [{ silent: true }]);
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            },
            onNodeUnchecked: function (event, node) {
                //if (node.nodes != null) {
                //    let nodeIds = []; node.nodes.forEach(n => nodeIds.push(n.nodeId));
                //    self.treeView.treeview('uncheckNode', [nodeIds, { silent: false }]);
                //}
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            },
            onMapBtnClicked: function (event, node) {
                // Get the correct node instance from the tree and then fire the nodeSelected event
                var nodeA = self.treeView.treeview('getNode', node.nodeId);
                nodeA.doNotOpenEditForm = true; // temp set this to stop the edit form being opened
                self.treeView.treeview('selectNode', [nodeA, { silent: false }]);
                // ****************************************************************************** //

                if (node.wkt) {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[node.wkt], true, true, node.featureType]));
                }
                else {
                    toastr.info('The record has no associated map feature')
                }
            }
        });

        if (colapseAll == true) {
            self.treeView.treeview('collapseAll');
        }

        self.checkVisibleButtons();
        self.updateNumberCheckedMessage();
    }

    private addData_to_treeData = (input: Array<INode>): void => {
        const self = this;
        let optionStr = $('#treeRectangleSelectOptions select').children("option:selected").val();
        switch (optionStr) {
            case "all":
                add_withParentNode(FeatureType.MaintParent); count(FeatureType.MaintParent);
                add_withParentNode(FeatureType.InfraParent); count(FeatureType.InfraParent);
                add_withParentNode(FeatureType.RouteParent); count(FeatureType.RouteParent);
                add_withParentNode(FeatureType.LandParent); count(FeatureType.LandParent);

                break;
            case "Route":
                add_noParentNode(FeatureType.RouteParent); count(FeatureType.RouteParent);
                break;
            case "Maint":
                add_noParentNode(FeatureType.MaintParent); count(FeatureType.MaintParent);
                break;
            case "Infra":
                add_noParentNode(FeatureType.InfraParent); count(FeatureType.InfraParent);
                break;
            case "Land":
                add_noParentNode(FeatureType.LandParent); count(FeatureType.LandParent);
                break;
            case "Path":
                add_noParentNode(FeatureType.PathParent); count(FeatureType.Path);
                break;
        }

        function add_noParentNode(featureType: FeatureType) {
            if (self.treeData == null) { self.treeData = []; }
            var inNode = input.find(f => f.featureType == featureType);
            if (inNode != null && inNode.nodes != null) {
                inNode.nodes.forEach(i => {
                    let index = self.treeData.findIndex(f => f.href == i.href);
                    if (index < 0) {
                        self.treeData.push(i); // Only add nodes if they are not already in the tree
                    }
                    else {
                        self.treeData[index] = i;
                    }
                });
            }
        }

        function add_withParentNode(featureType: FeatureType) {
            var inNode = input.find(f => f.featureType == featureType);
            if (inNode != null) {
                if (inNode.nodes != null && inNode.nodes.length > 0) {
                    if (self.treeData.find(f => f.featureType == featureType) == null) {
                        self.treeData.push(inNode);
                    }
                    else {
                        inNode.nodes.forEach(i => {
                            let n = self.treeData.find(f => f.featureType == featureType);
                            if (n != null) {
                                if (n.nodes == null) { n.nodes = []; }
                                if (n.nodes.findIndex(x => x.href == i.href) < 0) {
                                    n.nodes.push(i); // Only add nodes if they are not already in the tree
                                }
                            }
                        });
                    }
                }
            }
        }

        function count(featureType: FeatureType) {
            let outNode = self.treeData.find(f => f.featureType == featureType);
            if (outNode != null) {
                if (outNode.nodes == null) {
                    outNode.count = 0;
                }
                else {
                    outNode.count = outNode.nodes.length;
                }
            }
        }
    }

    private removeData_from_treeData = (data: ICAMSKey): void => {
        const self = this;

        // Search main nodes
        let index = self.treeData.findIndex(n => n.featureType == data.featureType && n.href == data.code);
        if (index >= 0) {
            self.treeData.splice(index, 1);
        }
        else {
            // If not, search child nodes
            self.treeData.forEach(p => {
                if (p.nodes != null) {
                    let index = p.nodes.findIndex(n => n.featureType == data.featureType && n.href == data.code);
                    if (index >= 0) {
                        p.nodes.splice(index, 1);
                        p.count = p.nodes.length;
                    }
                }
            });
        }
    }

    private updateNumberCheckedMessage = (): void => {
        let num = this.treeView.treeview('getChecked').length;
        let s = num > 1 ? "s" : "";
        Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "RecordList_ItemsSelectedLabel" }]).then(m => {
            let label = "items selected";
            if (m.success == true) label = m.data[0].value;

            if (num == 0) {
                $('#treeNumberCheckedBtn').hide();
            }
            else {
                $('#treeNumberCheckedBtn').html(`${num} ${label}`);
                $('#treeNumberCheckedBtn').show();
            }
        });
    }

    private checkVisibleButtons = (selectedNode: INode = null): void => {
        const self = this;
        let nodes: Array<INode> = self.treeView.treeview('getChecked');
        if (selectedNode != null && nodes.length == 0) nodes = nodes.concat(selectedNode); // Add the selected node to the list if it is not null

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => {
            self.actionBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the node type
        // If the row was just selected then also turn on the buttons
        if (nodes && nodes.length > 0) {
            if (self.authModel.enableTasksOnIssuesOnly == true) {
                if (nodes[0].featureType == FeatureType.Maint) {
                    self.actionBtns.newTask.enable = true;
                }
            }
            else {
                if (nodes[0].featureType == FeatureType.Maint || nodes[0].featureType == FeatureType.Route || nodes[0].featureType == FeatureType.Land || nodes[0].featureType == FeatureType.Infra) {
                    self.actionBtns.newTask.enable = true;
                }
            }
        }

        if (nodes && nodes.length == 1) {
            self.actionBtns.viewprint.enable = true;
            self.actionBtns.map.enable = true;
            self.actionBtns.export.enable = true
            self.actionBtns.annotate.enable = true;
            self.actionBtns.edit.enable = true;
            self.actionBtns.reparent.enable = true;
        }
        else if (nodes && nodes.length > 1) {
            self.actionBtns.viewprint.enable = true;
            self.actionBtns.map.enable = true;
            self.actionBtns.export.enable = true
            self.actionBtns.reparent.enable = true;
        }

        // If features cannot be reparented, then do not show the buttons
        nodes.forEach(n => {
            if (n.featureType == FeatureType.Land || n.featureType == FeatureType.Route) {
                self.actionBtns.reparent.enable = false;
            }
        });

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    // ----------------------------------------------------------- //
    // MISC
    private updateSelectionCountMessage = (): void => {
        let count = 0;
        if (this.treeData != null) count = this.treeData.length;
        let optionStr = $('#treeRectangleSelectOptions select').children("option:selected").text();

        Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "MapSelect_MapSelectLabel" }, { textPack: TextPack.OfficerMapTextPack, key: "MapSelect_RecordsSelectedLabel" }]).then(m => {
            let recordStr = "records"; let mapSelect = "Map Select";
            if (m.success == true) {
                recordStr = m.data[0].value; mapSelect = m.data[1].value;
            }
            $('#treeSelectCurrentCountMessage').html("<b>" + recordStr + ": </b>" + optionStr + " - " + count + ' ' + mapSelect + ' selected');
        });

        if (count == 0) {
            $('#treeResultsSelectedFeaturesPanel').hide();
            $('#treeSelectClearBtn').prop("disabled", true);
            $('#treeResultsPanelHeaderCount').html('');
        }
        else if (count > 0) {
            if ($('#rightSelectGroupPanel').hasClass('show') == false) $('#rightSelectGroupPanel').addClass('show');
            $('#treeResultsSelectedFeaturesPanel').show();
            $('#treeSelectClearBtn').prop("disabled", false);
            $('#treeResultsPanelHeaderCount').html(' (' + count + ')');
        }
    }

    private ClearSelection = (): void => {
        this.DeleteAllNodes();
        events.bus.publish(events.eventClearSelectedFeatures());
        this.updateSelectionCountMessage();
        if ($('#annotationRightSelectPanel').is(":visible") == false) $('#rightSelectGroupPanel').removeClass('show');
        $('#treeResultsSelectedFeaturesPanel').hide();
    }
}




